import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from "primeng/api";
import { CupService } from 'src/app/service/cup.service';
import { SharedService } from 'src/app/service/shared.service';
import { EnteDto } from 'src/app/model/ente';
import { UserClientService } from 'src/app/service/user-client.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogModel } from '../shared/rbk-modal/rbk-modal';

@Component({
  selector: 'app-ente-list',
  templateUrl: './ente-list.component.html',
  styleUrls: ['./ente-list.component.scss']
})
export class EnteListComponent {

  filteredTab: EnteDto[];
  selectedEnte: EnteDto;
  visible: boolean = false;
  isInEdit: boolean;
  public visibleDialog: boolean = false;
  public dialogModel: DialogModel;


  constructor(
    private entiServices: UserClientService,
    private spinner: NgxSpinnerService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.init()
  }

  init() {
    localStorage.removeItem('titoloCup');
    this.spinner.show()
    this.setupListEnte();
  }

  showDialog(ente?: EnteDto) {
    if (ente) {
      this.spinner.show()
      this.entiServices.getClientById(ente.id).subscribe({
        next: resp => {
         this.spinner.hide();
          this.selectedEnte = resp
          this.visible = true
          this.isInEdit = true
        },
        error: (err) => {
          this.spinner.hide();
        }
      })
    } else {
      this.visible = true;
      this.isInEdit = false;
      this.selectedEnte = undefined;
    }
  }

  confirm(id) {
    this.confirmationService.confirm({
      message: "Sei sicuro di vole eliminare questo ente?",
      header: "Eliminazione",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si, elimina",
      rejectLabel: "No, torna indietro",
      acceptButtonStyleClass: "p-button-danger p-button-text",
      rejectButtonStyleClass: "p-button-text",
      accept: async () => {
        const result = await this.entiServices.deleteClientById(id).toPromise();
        if (result) {
          this.dialogModel = {
            title: "Successo",
            message: "Ente eliminato con successo",
            btnConferma: "Chiudi",
            hasBtnAnnulla: false
          };
          this.visibleDialog = true;
          this.init();
        } else {
          this.dialogModel = {
            title: "Attenzione",
            message: "Non è stato possibile eliminare l'ente",
            btnConferma: "Chiudi",
            hasBtnAnnulla: false
          };
          this.visibleDialog = true;
        }
      },
      reject: () => {
        return;
      }
    });
  }

  onClose(bool) {
    this.visible = false;
    if (bool) {
      this.init();
    }
  }

  setupListEnte() {
    this.entiServices.getClient().subscribe({
      next: (resp) => {
        this.filteredTab = resp || [];
        this.spinner.hide();
      },
      error: (err) => {
        this.spinner.hide();
        this.dialogModel = {
          title: "Attenzione",
          message: "Non è stato possibile caricare la lista degli enti",
          btnConferma: "Chiudi",
          hasBtnAnnulla: false
        };
        this.visibleDialog = true;
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

}
